import { createSlice } from "@reduxjs/toolkit";

const initialState = {
      modal: false,
    };

const xoModalSlice = createSlice({
  name: "xoModalSlice",
  initialState: initialState,
  reducers: {
    openModal: (state, action) => {
      state.modal = true;
      return state;
    },
    closeModal: (state, action) => {
      state.modal = false;
      return state;
    },
  },
});

export const { openModal, closeModal } = xoModalSlice.actions;
export default xoModalSlice;
